import { ALERT_TYPES, NOTIFICATION_STATUS, VIEW_TYPES } from "../constants/OtherKeys.jsx";
import { STORE_KEYS } from "../constants/StoreKeys.jsx";
import { getIsArchivedForBoard } from "./otherUtils.jsx";
import { getSavedBoardSelection } from "../../react/hooks/useBoards.jsx";

export const VIEW_TO_STORE_KEY_MAP = {
  [VIEW_TYPES.resources]: STORE_KEYS.resourceStore,
  [VIEW_TYPES.tasks]: STORE_KEYS.taskStore,
  [VIEW_TYPES.clients]: STORE_KEYS.clientStore,
  [VIEW_TYPES.checklists]: STORE_KEYS.checklistStore,
  [VIEW_TYPES.notify]: STORE_KEYS.reminderStore,
  [VIEW_TYPES.users]: STORE_KEYS.boardUserStore,
  [VIEW_TYPES.contacts]: STORE_KEYS.contactStore,
  [VIEW_TYPES.reminder]: STORE_KEYS.reminderStore,
  [VIEW_TYPES.taskBudget]: STORE_KEYS.taskBudgetStore,
  [VIEW_TYPES.incentivePoints]: STORE_KEYS.incentivePointsStore,
}

const FILTER_CONDITIONS = {
  [VIEW_TYPES.reminder]: (reminder) =>  reminder.alertType === ALERT_TYPES.REMINDER && reminder.alertTag === "Reminder",
  [VIEW_TYPES.notify]: (notify) => notify.status === NOTIFICATION_STATUS.SENT
}

export const getCount = (store, viewType) => {
  const shouldIncludeRecord = FILTER_CONDITIONS[viewType] ?? (() => true);
  const isDisplayingArchivedRecords = getIsArchivedForBoard(getSavedBoardSelection().slug);
  return store.allRecords.filter((record) => (
    (isDisplayingArchivedRecords || !record.archived) &&
    !(record.isGroupHeader || record.isLinked)
    && shouldIncludeRecord(record))
  ).length;
};
